import { createApi, createDomain } from 'effector';
import produce, { type Draft } from 'immer';

const domain = createDomain('collapse');

type IdSet = Set<symbol>;
type CDraft = Draft<IdSet>;

export const $collapse = domain.store<IdSet>(new Set());

export const $collapseApi = createApi($collapse, {
  toggle: produce((draft: CDraft, payload: { id: symbol; isOn: boolean }) => {
    if (payload.isOn) {
      draft.add(payload.id);
    } else {
      draft.delete(payload.id);
    }
  }),
  toggleAll: (store, payload: { idSet: IdSet; isOn: boolean }) => {
    if (payload.isOn) {
      return new Set([...store, ...payload.idSet]);
    }
    return new Set([...store].filter((x) => !payload.idSet.has(x)));
  },
  reset: () => new Set(),
});
